import React from 'react'

interface Props {
	percent: number
}

const RADIUS = 9
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

/** A ring that fills as a download drains its queue. Decorative: the button around it carries the label. */
const ProgressRing: React.FC<Props> = ({ percent }) => (
	<svg className="download-ring" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
		<circle className="download-ring-track" cx="12" cy="12" r={RADIUS} />
		<circle
			className="download-ring-fill"
			cx="12"
			cy="12"
			r={RADIUS}
			strokeDasharray={CIRCUMFERENCE}
			strokeDashoffset={CIRCUMFERENCE * (1 - Math.min(100, Math.max(0, percent)) / 100)}
		/>
	</svg>
)

export default ProgressRing
